import "./Terms.css";

const TermApril = () => {
  return (
    <div className="tandc-page">
      <div className="tandc">
        {/*  Page Heading */}
        <h3 className="page-title" align="center">
          Terms and Conditions
        </h3>
        {/* Heading */}
        <h3 className="page-sub-title" align="center">
          Coke® Food Loot Promotion
        </h3>

        <div className="term-container">
          <div align="center">
            <table border="1" cellspacing="0" cellpadding="0" width="669">
              <tbody>
                <tr>
                  <td valign="top">
                    <p>
                      <strong>Clause</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Title</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Terms and Conditions</strong> <strong></strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>1</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>
                        Promotion Details, Concept and Participation
                      </strong>
                      <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p style={{ color: "blue" }}>
                      <strong>
                        This Promotion will commence at 12:00:00 pm Indian
                        Standard Time (IST) on 1
                      </strong>
                      <strong>
                        <sup>st</sup>
                      </strong>{" "}
                      <strong>
                        Jan 2026 and will continue until 10:00:00 pm IST on 30
                        <strong>
                          <sup>th</sup>
                        </strong>{" "}
                        April 2026 ("Promotion Period”). Any registrations
                        received outside the Promotion Period shall not be
                        eligible for the Prize(s) and shall not be carried
                        forward to any other promotional scheme ahead.
                      </strong>
                    </p>
                    <p>
                      <strong>Coke® Food Loot Promotion</strong>(“
                      <strong>Promotion</strong>”) is a consumer promotion
                      organised by Coca-Cola India Private Limited (“
                      <strong>CCIPL</strong>”), wherein participants (defined
                      hereinbelow) upon participating in accordance with the
                      terms and conditions herein stand a chance to win the
                      Prize(s) mentioned in Clause 7, in accordance with the
                      terms and conditions mentioned herein.
                    </p>
                    <p>
                      The Promotion shall be valid for the individuals residing
                      in India except for the states of Tamil Nadu)
                      <strong>(“Promotion Territory”)</strong>
                      and shall be accessible upon scanning the QR code on 1L,
                      1.05L, 1.25L, 1.5L, 2L, 2.25L of Coca-Cola® PET packs (“
                      <strong>Promotion Products</strong>”)<strong>.</strong>By
                      participating in this Promotion, the Eligible Persons as
                      per Clause 5 (each a “<strong>Participant</strong>”)
                      accepts and agrees to abide by these terms and conditions
                      of the Promotion (“ <strong>Promotion</strong>
                      <strong>Terms</strong>
                      ”).
                    </p>
                    <p>
                      It is hereby clarified that the Participant may
                      participate in the Promotion multiple times, but he/she
                      shall be eligible to win the Prize(s) as per Clause 7.
                    </p>
                    <p>
                      The Tier 2 Prize(s) will be allocated daily across the
                      Promotion Period and the limit allocated for the day will
                      be at CCIPL’s discretion. The daily allocation will be
                      dynamic and flexible. Day starts from 12:00 pm to 10:00pm.
                    </p>
                    <p>
                      The Promotion is advertised and promoted,
                      <em>inter alia</em>, through media including digital
                      media, point of sale materials, public announcements,
                      Platform, and other available media.
                    </p>
                    <p>
                      The Promotion is subject to all applicable central, state,
                      and local laws and regulations.
                    </p>
                    <p>
                      These Promotion terms and conditions (“
                      <strong>Terms</strong>”) will be hosted at{" "}
                      <a href="https://www.coke2home.com/coke-meals/OL/">
                        https://www.coke2home.com/coke-meals/OL/
                      </a>{" "}
                      <strong></strong>(“<strong>Promotion Platform</strong>”).
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>2</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>CCIPL and Partners</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      This Promotion is organised by CCIPL, having its corporate
                      office at 16th floor, One Horizon Center, Golf Course
                      Road, DFL Phase V, Sector 43, Gurgaon.
                    </p>
                    <p>And</p>
                    <p>
                      The operational part of the offer is managed by PREMIER
                      SALES PROMOTIONS PRIVATE LIMITED (“
                      <strong>BigCity Promotions</strong>"), a company governed
                      under the Companies Act, 1956 having its registered office
                      at Mitra Towers, 4 <sup>th</sup> Floor, Kasturba Road,
                      Bangalore 560 001 (hereinafter referred to as “
                      <strong>BigCity</strong>” or “<strong>Agency</strong>” or
                      “<strong>Promoter</strong>”)
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>3</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Deemed acceptance of terms and conditions</strong>
                      <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      Entry and participation in this Promotion will be deemed
                      as an unconditional and an unequivocal acceptance of these
                      Terms, including any modifications, revisions, and
                      amendments thereto. The decisions of CCIPL shall be final
                      and binding on the Participants in all matters related to
                      the Promotion. Further, the Participants recognize that
                      these Terms may be modified by CCIPL from time to time
                      without any prior/public notice by posting the applicable
                      terms and conditions on the Promotion Platform. CCIPL also
                      reserves the right to cancel or terminate the Promotion at
                      any stage without assigning any reasons whatsoever.
                      Successfully entering the Promotion and winning a Prize is
                      subject to all requirements set forth herein.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>4</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Promotion Period</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p style={{ color: "blue" }}>
                      <strong>
                        This Promotion will commence at 12:00:00 pm Indian
                        Standard Time (IST) on 1
                      </strong>
                      <strong>
                        <sup>st</sup>
                      </strong>{" "}
                      <strong>
                        Jan 2026 and will continue until 10:00:00 pm IST on 30
                      </strong>
                      <strong>
                        <sup>th</sup>
                      </strong>{" "}
                      <strong>
                        April 2026 ("Promotion Period”). Any registrations
                        received outside the Promotion Period shall not be
                        eligible for the Prize(s) and shall not be carried
                        forward to any other promotional scheme ahead.
                      </strong>
                    </p>
                    <p>
                      Stock of The Coca-Cola Company Products without the
                      Promotion offer will also be available across India.
                    </p>
                    <p>
                      Further, certain stock of The Coca-Cola Company Products
                      containing the Promotion offer may be available before the
                      Promotion Period or may continue to be available even
                      after the Promotion Period. However, prospective
                      Participants understand and agree that they will not be
                      permitted to participate in the Promotion before
                      commencement of the Promotion Period and after the expiry
                      of the Promotion Period and further, agree not to raise
                      any claim or complaint against CCIPL, its affiliates or
                      its agents in this respect.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>5</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Eligibility</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      Subject to the criteria of Promotion Territory, entry and
                      participation in this Promotion is open to individuals who
                      satisfy each of the following criteria (“
                      <strong>Eligible Persons</strong>”):
                    </p>

                    <div>
                      <ol type="i" start={1}>
                        <li>Must have attained 18 (eighteen) years of age.</li>
                        <li>
                          own a valid cellular GSM or CDMA phone connection and
                          internet connection that is accessible at all times.
                        </li>
                        <li>
                          bear a good moral character and have not been
                          implicated or named in any legal proceedings (either
                          civil or criminal).
                        </li>
                        <li>
                          are not management, employees, directors or
                          contractors, or the family of the management,
                          employees, directors or contractors of CCIPL, their
                          related entities or other agencies, firms or companies
                          associated with or related to the Promotion (including
                          suppliers of Prizes).
                        </li>
                      </ol>
                    </div>

                    <p>
                      Please note that any entry received from states other than
                      the Promotion Territory shall be declared as null and void
                      and shall not be taken into consideration for determining
                      the Winners of the Prize.
                    </p>
                    <p>
                      For the sake of clarity, this Promotion is not open to
                      Non-Resident Indians (NRIs), Overseas Citizens of India
                      (OCIs) and Persons of Indian Origin (PIOs).
                    </p>
                    <p>
                      Eligible Persons participating or seeking to participate
                      in the Promotion shall individually be referred to as “
                      <strong>Participant</strong>” and collectively as “
                      <strong>Participants</strong>”.
                    </p>
                    <p>
                      If any Eligible Person has listed his/her phone numbers on
                      the National Do Not Call Registry (“
                      <strong>NDNC Registry</strong>”), he/she shall de-register
                      from the NDNC Registry prior to participating in the
                      Promotion, till the completion of the Promotion (including
                      availing of the Prize (if applicable) under the
                      Promotion). Such persons agree not to make any claim or
                      raise any complaint whatsoever against CCIPL in this
                      respect. Please note that persons intending to participate
                      in the Promotion who have not de-registered themselves
                      from the NDNC Registry shall also have no right to make
                      any claim or raise any complaints against CCIPL, if they
                      do or do not receive any call or SMS with respect to their
                      application, participation and all other matters
                      pertaining to the Promotion.
                    </p>
                    <p>
                      By participating in the Promotion, each Participant hereby
                      agrees to receive:
                    </p>

                    <div>
                      <ol>
                        <li>
                          details and information on this Promotion, on their
                          respective mobile phones, through SMS or voice calls,
                          during the entire tenure of the Promotion.
                        </li>
                        <li>
                          updates and announcements concerning CCIPL’s products
                          and promotions, on their respective mobile phones
                          (through SMS or voice calls) and Email Ids.
                        </li>
                      </ol>
                    </div>

                    <p>
                      <strong>(“Marketing Communication”)</strong>
                    </p>
                    <p>
                      The Participant may opt-out of receiving Marketing
                      Communication from CCIPL at any time by emailing or
                      calling, using the contact information listed below. In
                      such a request, the Participant must indicate that he/she
                      wishes to stop receiving Marketing Communication from
                      CCIPL.
                    </p>
                    <p>
                      Email:{" "}
                      <a href="mailto:indiahelpline@coca-cola.com">
                        indiahelpline@coca-cola.com
                      </a>
                    </p>
                    <p>Consumer Helpline: 1800-208-2653</p>
                    <p>Timings:</p>
                    <p>9:00am–9:00pm (Mon-Sat)</p>
                    <p>9:00am-6:00pm (Sun)</p>
                    <p>
                      The Participant hereby agrees that he/she has read and
                      understood the Privacy Policy mentioned on the Promotion
                      Platform and provides his/her unconditional consent to
                      collection of his/her personal information namely Name,
                      Mobile Number, Email ID, Address and Location. Further,
                      the Participant hereby provides his/her consent for
                      storage and processing of his/her personal information
                      collected for the purposes of sending communication
                      including but not limited to Marketing Communication.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>6</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Participating in the Promotion</strong>
                      <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      The Participant can participate subject to the following
                      terms:
                    </p>

                    <div>
                      <ol>
                        <li>Buy a Coca-Cola® Promotional Product</li>
                        <li>
                          Scan QR code to to visit Coca-Cola® official WhatsApp
                          channel.
                        </li>
                        <li>
                          By registering, the Participant(s) consent to the
                          Terms &amp; Conditions and the handling of personal
                          information as per the Privacy Policy posted on the
                          Coca-Cola® official WhatsApp channel.
                        </li>
                        <li>
                          Upon entering the valid unique code found inside the
                          label of Promotional Product, the Participant will win
                          the Tier 2 Prize.
                        </li>
                        <li>
                          The Participant(s) will be notified immediately as
                          they enter the valid unique code if they are winner.
                        </li>
                        <li>
                          The Winner shall redeem their Prize(s) on Domino’s
                          platform.
                        </li>
                        <li>
                          Additional Gift card terms and conditions shall be
                          applicable on Domino’s Platform.
                        </li>
                        <li>
                          Each Participant will receive one (1) digital sticker
                          (“Food Stamp”) for every valid unique code submitted.
                        </li>
                        <li>
                          Upon collecting two (2) unique Food Stamp(s), the
                          Participant will be awarded the Tier 1 Prize as
                          detailed in Clause 7.
                        </li>
                      </ol>
                    </div>

                    <p style={{ textDecoration: "underline" }}>
                      Other terms &amp; conditions:
                    </p>
                    <div>
                      <ol>
                        <li>
                          Participants may participate any number of times for
                          winning the Prize(s), however, it is hereby clarified
                          that each Participant shall be eligible to win the
                          Prize(s) as per Clause 7.
                        </li>
                        <li>
                          All earned rewards will be visible in the My Winnings
                          section of the Promotion Platform for each
                          Participant.
                        </li>
                        <li>
                          The Participant(s) must redeem their Tier 2 Prize(s)
                          before 30th June 2026, and their Tier 1 Prize(s)
                          before 31 <sup>st</sup> December 2026 to avoid
                          forfeiture. The expiry date for Domino’s vouchers and
                          Domino’s Coupons will be clearly indicated upon
                          winning the Prize(s)."
                        </li>
                        <li>
                          Any forfeiture exercised will be binding and final on
                          the participants.
                        </li>
                      </ol>
                    </div>

                    <p>
                      Entry by proxy is not permitted. Participants can only
                      enter in their own name. The Participants shall be solely
                      responsible for any local calls / STD charges applicable
                      by their telecom service providers on the Promotion
                      entries.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>7</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Prizes and Winners</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      During the Promotion Period, Participants on the basis of
                      valid participation as per the Terms of Clause 6, shall be
                      eligible to win the following Prize(s):
                    </p>
                    <p style={{ textDecoration: "underline" }}>
                      <strong>
                        Tier 1 (Once per mobile number during the Promotion
                        Period)
                      </strong>
                    </p>

                    <div>
                      <ul>
                        <li>
                          INR 999.99 voucher with same voucher code being
                          applicable 10 times per user per mobile number.
                          Totalling 9999 worth of Vouchers and subject to terms
                          and conditions as may be applicable on the Dominos
                          Platform.
                        </li>
                      </ul>
                    </div>

                    <p>
                      <strong>
                        Tier 2: (Up to 4 times per mobile number during the
                        Promotion Period)
                      </strong>
                    </p>
                    <ul>
                      <li>
                        <strong>
                          One of the below rewards: <br />
                        </strong>
                        A. INR 100 off on orders above INR 399 <br />
                        B. Free garlic bread on orders above INR 399 <br />
                        C. INR 75 off on orders above INR 249
                      </li>
                    </ul>
                    <p>
                      And subject to terms and conditions as may be applicable
                      on the Dominos Patform.
                    </p>
                    <p>
                      The winners of the Prize(s) (each a “
                      <strong>Winner</strong>”) may access details of their
                      Prize(s) under the My Winnings section of the Promotion
                      Platform.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>8</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Selecting and contacting Eligible Winners</strong>
                      <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <ol>
                      <li>
                        The Participants will be eligible to receive the Prize
                        subject to the Terms detailed herein.
                      </li>
                      <li>
                        Winners will be selected based on the valid unique code
                        submitted for Tier 2 Prize(s) and the collection of four
                        (2) unique Food Stamp(s) for Tier 1 Prize(s) from the
                        pool of valid submissions/ entries, in accordance with
                        these Terms &amp; Conditions.
                      </li>
                      <li>
                        The Participants acknowledge not to raise any claim or
                        complaint against CCIPL due to technical failure or any
                        other causes beyond the control of CCIPL.
                      </li>
                      <li>
                        Prizes once awarded cannot be replaced under any
                        circumstances.
                      </li>
                    </ol>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>9</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Conditions relating to the Prize</strong>
                      <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <ol type="i" start={1}>
                      <li>
                        CCIPL shall not be held responsible for any deficiency,
                        defect, inadequacy, or irregularity in the Prize(s). The
                        Winner(s) may not exchange or assign the Prizes and
                        shall not be entitled to any compensation whether in
                        cash or kind from CCIPL.
                      </li>
                      <li>
                        No portion of the Prizes offered under the Promotion is
                        redeemable for cash or kind from CCIPL. The Prizes are
                        also not refundable or transferable and cannot be
                        exchanged.
                      </li>
                      <li>
                        No Prize will be awarded if the information presented by
                        the Participant(s) at the time of entering the
                        Promotion, or at any subsequent stage is factually
                        incorrect.
                      </li>
                      <li>
                        In the event of death of the Winner, no claim from the
                        nominee or his/her legal heirs of the Winner shall be
                        entertained for receiving the Prize.
                      </li>
                      <li>
                        The Prizes shall be provided to the Winners on an "as-is
                        basis" and without any warranty or guarantee concerning
                        the quality, suitability or comfort, and CCIPL and/or
                        its associates, affiliates and/ or its management,
                        directors, officers, agents, representatives shall not
                        be responsible for or liable (including but not limited
                        to the product and service liabilities) for deficiency
                        and/ or defect of any product/service and/or the Prize
                        or for any kind of consequential damages/ loss, in any
                        manner whatsoever. The guarantee and warranty of the
                        Prizes shall be transferred to the Winners as received
                        from the Manufacturer / Distributor.
                      </li>
                      <li>
                        If any Participant has any grievance with respect to the
                        Prize, he/she may directly contact the manufacturer.
                      </li>
                      <li>
                        No request for change in make, model, color,
                        specifications etc. of the Prize shall be entertained.
                      </li>
                      <li>
                        The image of the Prize depicted on the press
                        ads/posters/TVC's/pack shots etc. are for illustrative
                        purposes only and the actual Prize may vary from the
                        depiction made.
                      </li>
                      <li>
                        It is to be noted that in the event the Winner does not
                        take the Prize in the time and manner stipulated, then
                        the Prize shall be forfeited by the Winner and cash or
                        any monetary benefits in kind shall not be awarded in
                        lieu of the Prize. Prizes must be taken as offered and
                        cannot be varied.
                      </li>
                    </ol>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>10</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Publicity</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      The Participants undertake and irrevocably and
                      unconditionally permit CCIPL to cover the Promotion
                      through various media including newspapers, radio,
                      television including news and other channels, internet,
                      point of sale materials, etc., and shall not raise any
                      objection, protest, or demur whatsoever to such coverage
                      or in this regard. Further, the Participants also
                      understand and agree that their responses may be
                      publicised as part of this Promotion.
                    </p>
                    <p>
                      The Winners must, at the request of CCIPL, participate in
                      all promotional activity (such as publicity and
                      photography) surrounding the winning of the Prize, free of
                      charge, and they consent to CCIPL using their name and
                      image in all promotional materials.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>11</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Intellectual Property</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      All right, title, and interest, including but not limited
                      to the Intellectual Property Rights, in the promotional
                      material(s), and in any and all responses received, or
                      other materials created during or for the Promotion, as a
                      part of the Promotion or otherwise, shall vest solely and
                      exclusively with CCIPL at all times. CCIPL or any person
                      or entity permitted by CCIPL in this regard shall be
                      entitled to use any information in connection with the
                      entry in any media for future promotional, marketing,
                      publicity and any other purpose, without any permission
                      and or payment to the Participant. CCIPL may use the
                      material in any medium in any reasonable manner it sees
                      fit. Copyright in any such material remains the sole
                      property of CCIPL.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>12</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>General Conditions</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>General Terms and Conditions:</strong>
                    </p>
                    <ul>
                      <li>
                        Each Participant represents and warrants that he/she is
                        legally competent to enter into binding contracts under
                        applicable laws. By taking part and/or entering into the
                        Promotion the Participant warrants that all information
                        provided by Participant regarding Participant's name,
                        age, state, city, address, phone number, etc., is true,
                        correct, accurate and complete.
                      </li>
                      <li>
                        The decision of CCIPL or the Agency, as regards the
                        selection of winners and distribution of the prizes
                        shall be final, subject only to CCIPL ‘s approval. No
                        correspondence or any other claims whatsoever, in this
                        regard will be entertained.
                      </li>
                      <li>
                        No queries, claims, dispute, complaints or grievances
                        shall be entertained by CCIPL and the Agency after 60
                        days from the date of the closure of the Promotion.
                      </li>
                      <li>
                        The prize cannot be exchanged and is not transferable
                        and cannot be converted into cash.
                      </li>
                      <li>
                        The Agency shall provide the prize on an "as-is basis"
                        and without any warranty or guarantee concerning the
                        quality, suitability or comfort, and CCIPL and/or its
                        associates, affiliates and/ or its management,
                        directors, officers, agents, representatives shall not
                        be responsible for or liable (including but not limited
                        to the product and service liabilities) for deficiency
                        and/ or defect of any product/service and/or the prize
                        or for any kind of consequential damages/ loss, in any
                        manner whatsoever.
                      </li>
                      <li>
                        CCIPL reserves the right to change, defer, alter or
                        cancel this Promotion in part or full, or change any or
                        all of the terms and conditions that are applicable,
                        without giving prior intimation/notice of any kind and
                        will not be liable for any consequential losses/damages.
                        Any decision of CCIPL in this regard and in general with
                        respect to this Promotion and the terms and conditions
                        thereto shall be final, binding and non-Offer able.
                      </li>
                      <li>
                        Nothing contained herein amounts to a commitment or
                        representation by CCIPL to conduct further Promotion.
                      </li>
                      <li>
                        CCIPL reserves the right to change any details of the
                        Promotion, including but not limited to amending these
                        terms and conditions, the type of Promotion, submission
                        mechanism, eligibility criteria, term of the Promotion,
                        and the prizes for the Promotion. CCIPL reserves the
                        right to amend, temporarily suspend or withdraw the
                        Promotion in its absolute discretion provided that CCIPL
                        shall not exercise this right unreasonably.
                      </li>
                      <li>
                        CCIPL shall not be liable to award/provide the prize(s)
                        and/or declare the winners of the prizes of the
                        Promotion due to any cause beyond its reasonable control
                        or foresight, including but not limited to, act of god,
                        insurrection or civil disorder, religious strife, war or
                        military operations, terrorist act, partial or total
                        strikes, either internal or external, lock-out,
                        epidemic, blockage of means of transport or of supplies,
                        national or local emergency, earthquake, fire, storm,
                        flood, water damage, governmental, regulatory or legal
                        restrictions, acts or omissions of persons for whom
                        CCIPL is not responsible.
                      </li>
                      <li>
                        The decision of CCIPL shall be final in all regards and
                        no communication shall be entertained in this regard.
                        None of the provisions of these Terms and Conditions
                        shall be deemed to constitute a partnership or agency
                        between any Participant and CCIPL and the Participant
                        shall not have the authority to bind CCIPL in any manner
                        whatsoever.
                      </li>
                      <li>
                        CCIPL or any of its respective
                        officers/employees/directors shall not be responsible
                        for delayed, lost, mutilated, corrupted or illegible
                        documents etc.
                      </li>
                      <li>
                        CCIPL or the Agency shall not be liable to perform any
                        of its/their respective obligations under the Promotion
                        or in respect of the prize where it is unable to do so
                        as a result of circumstances beyond its/their control in
                        the nature of fire, explosions, natural calamities,
                        state emergency, riots, or any other Force Majeure
                        condition, etc., and shall not be liable to compensate
                        the Participant in these circumstances.
                      </li>
                      <li>
                        CCIPL or the Agency shall not be accountable/liable for
                        any disruptions/stoppages/interruptions or cancellation
                        of the Promotion due to any government restrictions.
                      </li>
                      <li>
                        Failure to exercise or delay in exercising a right or
                        remedy provided hereunder or by law does not constitute
                        a waiver of the right or remedy or waiver of other
                        rights or remedies on the part of CCIPL or the Agency.
                      </li>
                      <li>
                        CCIPL or the Agency accepts no responsibility for late,
                        lost, incomplete, incorrectly submitted, delayed,
                        illegible, corrupted or misdirected entries, loss of
                        SMS, loss of internet connectivity, unique codes,
                        documents, demand drafts, claims or correspondence
                        whether due to error, omission, alteration, tampering,
                        unauthorized data hacking, deletion, theft, destruction,
                        virus attack, transmission interruption, communications
                        failure, hardware failure or otherwise. CCIPL or the
                        Agency shall not be liable for any consequences of user
                        error including (without limitation) costs incurred.
                      </li>
                      <li>
                        If a Participant is dissatisfied with the Promotion or
                        the Promotion rules and/or any content or any
                        requirements of the Promotion form, the materials
                        available related thereto, or with these terms and
                        conditions, his/her sole and exclusive remedy is to not
                        participate in the Promotion.
                      </li>
                      <li>
                        If a person chooses to access the Promotion Platform
                        from outside India, he/she shall do so on his/her own
                        initiative and shall be responsible for compliance with
                        applicable local laws of the country.
                      </li>
                      <li>
                        The operational part of the scheme like redemption of
                        prize &amp; dispatches shall be managed by the Agency;
                        However, promotional product will be distributed through
                        CCIPL Distributor/dealer.
                      </li>
                      <li>
                        The participation in the Promotion is purely voluntary
                        and the same shall be construed as an acceptance of the
                        terms and conditions stipulated herein.
                      </li>
                      <li>Release and Limitations of Liability:</li>
                    </ul>
                    <ol  type="i" start={1} style={{marginLeft:"0.5rem", marginTop:"0.5rem"}}>
                      <li>
                        CCIPL and the Agency shall under no circumstances be
                        liable, whether jointly or severally, for any loss or
                        damage suffered or sustained (including but not limited
                        to consequential loss), including for personal injury or
                        property damage suffered or sustained, as a result of
                        acceptance of any prize.
                      </li>
                      <li>
                        By entering the Promotion, the Participant hereby
                        releases from and agrees to indemnify CCIPL, and/ or any
                        of its respective officers/employees from and against
                        all liability, cost, loss or expense arising out of
                        acceptance of the prize or participation in the
                        Promotion including (but not limited to) personal injury
                        and damage to property and whether direct, indirect,
                        consequential, foreseeable, due to some negligent act or
                        omission, or otherwise.
                      </li>
                      <li>
                        CCIPL and the Agency accept no liability, whether
                        jointly or severally, for any errors or omissions,
                        whether on behalf of itself, Agency or third parties in
                        relation to the prizes.
                      </li>
                      <li>
                        The Participant shall be solely responsible for any
                        consequences which may arise due to his/her
                        participation in the Promotion by conducting an illegal
                        act. Participant also undertakes to indemnify CCIPL
                        and/or the Agency and their respective officers,
                        directors, employees and agents on the happening of such
                        an event (including without limitation cost of attorney,
                        legal charges etc.) on full indemnity basis for any
                        loss/damage suffered by CCIPL or the Agency on account
                        of such act on the part of the Participant.
                      </li>
                      <li>
                        In consideration of CCIPL allowing the Participant(s) to
                        take part in the Promotion , to the maximum extent
                        permitted by law, the Participant(s) waive and release
                        each and every right or claim, all actions, causes of
                        actions (present or future) each of them has or may have
                        against CCIPL , its respective agents, directors,
                        officers, business associates, group companies,
                        sponsors, employees, or representatives for all and any
                        injuries, accidents, or mishaps (whether known or
                        unknown) or (whether anticipated or unanticipated)
                        arising out of the Promotion or related to the Promotion
                        or the prize of the Promotion.
                      </li>
                    </ol>
                    <p>14. Additional General Terms and Conditions</p>
                    <ul>
                      <li>
                        This Promotion is not available to employees, of CCIPL
                        and the Agency, its clients or agencies and their
                        immediate families.
                      </li>
                      <li>
                        Any costs associated with entering the Promotion,
                        including accessing the Promotion Platform, are the
                        responsibility of each Participant. Also, regular call
                        and message rates will apply as per the consumer telecom
                        operator in their respective circles.
                      </li>
                      <li>
                        The Agency is acting as an executing agency for this
                        Promotion and holds no legal and financial liability on
                        unclaimed Prize (s), incentives, etc. beyond the
                        applicable period of the Promotion.
                      </li>
                      <li>
                        This Promotion is subject to promotional availability
                        and government regulations.
                      </li>
                      <li>
                        The Agency &amp; CCIPL reserves the right to change the
                        terms and conditions of this scheme, including
                        extending, withdrawing, or discontinuing the same
                        without notice, without assigning any reason, at their
                        sole discretion and without any liability.
                      </li>
                      <li>
                        If this promotion is interfered with in any way or is
                        not capable of being conducted as reasonably anticipated
                        due to any reason beyond the reasonable control of the
                        Agency, including but not limited to technical
                        difficulties, unauthorized intervention or fraud, the
                        Agency reserves the right, in its sole discretion, to
                        the fullest extent permitted by law (a) to invalidate
                        any customer; or (b) subject to any written directions
                        from a regulatory authority, to modify, suspend,
                        terminate or cancel the promotion, as appropriate.
                      </li>
                      <li>
                        The Agency or CCIPL is not responsible for any problems
                        or technical malfunction of any telephone or network or
                        lines, servers or providers, computer equipment,
                        software, technical problems or traffic congestion on a
                        mobile network, or any combination thereof, or any other
                        technical failures including any damage to Participant's
                        or any other person's mobile handset or computer related
                        to, or resulting from, participation in this Promotion
                        or the downloading of any materials related to this
                        Promotion
                      </li>
                      <li>
                        If for any reason this Promotion is not capable of
                        running as planned because of infection by computer
                        virus, bugs, tampering, unauthorized intervention,
                        technical failures or any other causes beyond the
                        reasonable control of the Agency which corrupt or affect
                        the administration, security, fairness, integrity or
                        proper conduct of this Promotion, the Agency or CCIPL
                        reserves the right in its sole discretion to cancel,
                        terminate, modify or suspend the Promotion, subject to
                        any written directions made under applicable State or
                        Territory legislation.
                      </li>
                      <li>
                        Caution: Any attempt to deliberately damage the Agency’s
                        Promotion Platform or the information on the Promotion
                        Platform, to cause malicious damage or interference with
                        the normal functioning of the Promotion Platform, or to
                        otherwise undermine the legitimate operation of this
                        Promotion may be a violation of criminal and civil laws
                        and should such an attempt be made, whether successful
                        or not, the Agency reserves the right to seek damages to
                        the fullest extent permitted by law. If the Agency
                        suffers loss or incurs any costs in connection with any
                        breach of these Terms or any other legal obligation by a
                        Participant, the Participant agrees to indemnify the
                        Agency for those losses, damages, and costs.
                      </li>
                      <li>
                        The Agency, its clients, agents, and distributors accept
                        no responsibility, financial or otherwise for the misuse
                        of the Prize(s)and are not liable for any personal loss
                        or injury and cannot be held responsible for any
                        disagreement concerning quality/ availability of the
                        Prize(s).
                      </li>
                      <li>
                        CCIPL does not endorse the quality of any of the
                        products or services being offered by the Agency or by
                        the Promotion partner. Any complaints or queries
                        pertaining to the same would have to be taken up
                        directly with the Agency marketing of such a product or
                        service.
                      </li>
                      <li>
                        The Agency, its clients, agents, and distributors cannot
                        replace any lost, stolen or damaged Prize(s) and reserve
                        the right to withdraw or amend any details and/or prices
                        without notice.
                      </li>
                      <li>
                        All the Prize(s) supplied by the Agency, Mitra Towers,
                        Kasturba Road, Bangalore 560001, India.
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>13</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Release and Limitations of Liability</strong>
                      <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <ol type="i" start={1}>
                      <li>
                        By entering the Promotion, the Participants hereby
                        release from and agree to indemnify CCIPL, and/ or any
                        of their respective officers/employees from and against
                        all liability, cost, loss or expense arising out of
                        acceptance of the Prize or participation in the
                        Promotion including (but not limited to) personal injury
                        and damage to property and whether direct, indirect,
                        consequential, foreseeable, due to some negligent act or
                        omission, or otherwise.
                      </li>
                      <li>
                        CCIPL accept no liability, whether jointly or severally,
                        for any errors or omissions, whether on behalf of
                        themselves or third parties in relation to the Prizes.
                        CCIPL, and any of their respective parent companies,
                        subsidiaries, affiliates, directors, officers,
                        professional advisors, employees and agencies will not
                        be responsible for any late, lost, misrouted, or
                        distorted or damaged transmissions or entries.
                      </li>
                      <li>
                        The Participant(s) shall be solely responsible for any
                        consequences which may arise due to their participation
                        in the Promotion by conducting an illegal act.
                        Participant(s) also undertakes to indemnify CCIPL and
                        their respective officers, directors, employees and
                        agents on the happening of such an event (including
                        without limitation cost of attorney, legal charges etc.)
                        on full indemnity basis for any loss/damage suffered by
                        CCIPL on account of such act on the part of the
                        Participant. Participant(s) hereby agree to indemnify,
                        defend and hold harmless CCIPL in case of any loss or
                        liability (including but not limited to liabilities,
                        judgments, damages, losses, fines and penalties, claims,
                        costs and expenses such as attorneys’ fees and expenses)
                        or any other loss associated with, arising out of or
                        incidental to their ineligibility to participate, any
                        untoward, rash or negligent act on their part, or
                        non-compliance or alleged non-compliance with these
                        Terms, any other rules, regulations, directives (whether
                        written or verbal) issued by CCIPL from time to time,
                        during the Promotion.
                      </li>
                      <li>
                        To the fullest extent permitted by law, in no event will
                        CCIPL or any of its officers, servants, employees,
                        representatives and/or agents (including without
                        limitation, any third party service providers that CCIPL
                        may engage for purposes of the Promotion), be liable for
                        any loss or damages (including, without limitation loss
                        of income, profits or goodwill, indirect, incidental,
                        consequential, exemplary, punitive or special damages of
                        any party including third parties) howsoever arising
                        whether in contract, tort, negligence or otherwise, in
                        connection with the Promotion and/or the Promotion
                        Prizes, even if CCIPL has been advised of the
                        possibility of such damages in advance, and all such
                        damages are expressly excluded. The Participant shall
                        indemnify, defend, and hold CCIPL harmless in the event
                        of there being any third party/entity/organization
                        claims arising from or related to his/her participation
                        in the Promotion. In no event shall CCIPL and be liable
                        to any Participant for acts or omissions arising out of
                        or related to the Promotion or his/her participation in
                        the Promotion.
                      </li>
                      <li>
                        In consideration of CCIPL allowing the Participant(s) to
                        take part in the Promotion, to the maximum extent
                        permitted by law, the Participant(s) waive and release
                        each and every right or claim, all actions, causes of
                        actions (present or future) each of them has or may have
                        against CCIPL, its respective agents, directors,
                        officers, business associates, group companies,
                        sponsors, employees, or representatives for all and any
                        injuries, accidents, or mishaps (whether known or
                        unknown) or (whether anticipated or unanticipated)
                        arising out of the Promotion or related to the Promotion
                        or the Prizes of the Promotion.
                      </li>
                    </ol>
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <p>14</p>
                  </td>
                  <td valign="top">
                    <p>
                      <strong>Dispute</strong> <strong></strong>
                    </p>
                  </td>
                  <td valign="top">
                    <ol  type="i" start={1}>
                      <li>
                        The courts of competent jurisdiction at Gurgaon shall
                        have exclusive jurisdiction to determine any and all
                        disputes arising out of, or in connection with, the
                        Promotion.
                      </li>
                      <li>
                        Participation in the Promotion is unauthorized in any
                        jurisdiction that does not give effect to all provisions
                        of these Terms, including without limitation, this
                        clause.
                      </li>
                      <li>
                        Further all issues and questions concerning the
                        construction, validity, interpretation and
                        enforceability of these Terms, or the rights and
                        obligations of the Participants and/or CCIPL and/or
                        partners of this Promotion, shall be governed and
                        construed in accordance with the laws of the Republic of
                        India.
                      </li>
                    </ol>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermApril;
